import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from 'formik'
import * as bie from "react-bootstrap";
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { VscDiffAdded } from 'react-icons/vsc';
import Swal from 'sweetalert2';
import { failureAlert, successAlertRefresh } from '../../CommonUtils/SweetAlerts';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import * as Yup from 'yup';
import allowNumbersOnly, { allowFloatNumbers2, handlePaste } from '../../CommonUtils/CommonValidations';
import { useSelector } from 'react-redux';
import { BiTrash } from 'react-icons/bi';
import { GetCollegeType } from '../../Reducers/AffiliationCommonservice';
export default function AffliationLibrary2021() {
  const Collegetype = useSelector((state) => state?.commonMastersReducer?.CollegeType);

  const AfflLibraryValidation = Yup.object({
    libraryCarpetArea: Yup.string().required(ERROR_MSG).nullable(),
    readingRoomCapacity: Yup.string().required(ERROR_MSG).nullable(),
    repgraphicPhtgraphic: Yup.string().required(ERROR_MSG).nullable(),
    automationSoftware: Yup.string().required(ERROR_MSG).nullable().nullable(),
    supportingStaff: Yup.string().required(ERROR_MSG).nullable(),
    booksJournals: Yup.string().required(ERROR_MSG).nullable(),
    digital: Yup.string().required(ERROR_MSG).nullable(),
    noComputers: Yup.string().required(ERROR_MSG).nullable(),
    nptel: Yup.string().required(ERROR_MSG).nullable(),
    accessOnlineCourse: Yup.string().required(ERROR_MSG).nullable(),
    noTerminalsInternetConnection: Yup.string().required(ERROR_MSG).nullable(),
    internetMbps: Yup.string().required(ERROR_MSG).nullable(),
    areaExaminationWing: Yup.string().required(ERROR_MSG).nullable(),
    computerSystems: Yup.string().required(ERROR_MSG).nullable(),
    highSpeed: Yup.string().required(ERROR_MSG).nullable(),
    internetBandwidth: Yup.string().required(ERROR_MSG).nullable(),
    separateRoom: Yup.string().required(ERROR_MSG).nullable(),

    journalsDetails: Yup.array().of(Yup.object().shape({
      noOfTitles: Yup.string().nullable().required(ERROR_MSG).nullable(),
      noOfVolumes: Yup.string().nullable().required(ERROR_MSG).nullable(),
      noOfNational: Yup.string().nullable().required(ERROR_MSG).nullable(),
      noOfInternational: Yup.string().nullable().required(ERROR_MSG).nullable(),
      noOfEjournals: Yup.string().nullable().required(ERROR_MSG).nullable(),
    })),
    softwareDetails: Yup.array().of(
      Yup.object().shape({
        softwareCode: Yup.string().required(ERROR_MSG).nullable(),
        othersEntry: Yup.string().when('softwareCode', {
          is: '9999',
          then: Yup.string().required(ERROR_MSG).nullable(),
          otherwise: Yup.string().nullable(),
        }),
        noOfLicenses: Yup.string().required(ERROR_MSG).nullable(),
      })
    )


  });
  const [software, setsoftware] = useState([]);
  function SoftwaresData() {
    let url = config.url.API_URL + `getSoftwares`;
    CommonAxiosGet(url).then((res) => {

      if (res?.data?.scode === '01') {
        setsoftware(res?.data?.Softwares);

      }
      else {
        setsoftware([]);
      }
    })
  }

  function GetSoftwareSubmittedData() {
    let url = config.url.API_URL + `getSoftwareData`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === '01') {
        res?.data?.librarysoftwaredata?.forEach((data, i) => {
          AfflLabFormik?.setFieldValue(`softwareDetails[${i}].softwareCode`, data?.software_code.toString());
          AfflLabFormik?.setFieldValue(`softwareDetails[${i}].noOfLicenses`, data?.no_of_licenses);
          AfflLabFormik?.setFieldValue(`softwareDetails[${i}].othersEntry`, data?.others_entry);


        });

      }
      else {
        console.log("DATA NOT FOUND")

      }
    })
  }


  const [Journals, setJournals] = useState([])
  function GetJournalsSubmittedData() {
    let url = config.url.API_URL + `getJournalsData`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === '01') {
        setJournals(res?.data?.libraryjournaldata)
        setJournals(res?.data?.libraryjournaldata);
        res?.data?.libraryjournaldata?.forEach((data, i) => {
          AfflLabFormik?.setFieldValue(`journalsDetails[${i}].courseCode`, data?.course_id);
          AfflLabFormik?.setFieldValue(`journalsDetails[${i}].noOfTitles`, data?.no_of_titles);
          AfflLabFormik?.setFieldValue(`journalsDetails[${i}].noOfVolumes`, data?.no_of_volumes);
          AfflLabFormik?.setFieldValue(`journalsDetails[${i}].noOfNational`, data?.no_of_national);
          AfflLabFormik?.setFieldValue(`journalsDetails[${i}].noOfInternational`, data?.no_of_international);
          AfflLabFormik?.setFieldValue(`journalsDetails[${i}].noOfEjournals`, data?.no_of_ejournals);
        });

      }
      else {
        setJournals([]);
      }
    })
  }
  function GetLibrarySubmittedData() {
    let url = config.url.API_URL + `getLibraryFacilityData`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === '01') {
        const LibraryData = res?.data?.libraryfacilitydata[0] || [];
        AfflLabFormik?.setFieldValue("libraryCarpetArea", LibraryData?.library_carpet_area);
        AfflLabFormik?.setFieldValue("readingRoomCapacity", LibraryData?.reading_room_capacity);
        AfflLabFormik?.setFieldValue("repgraphicPhtgraphic", LibraryData?.repgraphic_phtgraphic == true ? "true" : LibraryData?.repgraphic_phtgraphic == false ? "false" : '');
        AfflLabFormik?.setFieldValue("automationSoftware", LibraryData?.automation_software == true ? "true" : LibraryData?.automation_software == false ? "false" : "");
        AfflLabFormik?.setFieldValue("booksJournals", LibraryData?.books_journals);
        AfflLabFormik?.setFieldValue("digital", LibraryData?.digital == true ? "true" : LibraryData?.digital == false ? "false" : "");
        AfflLabFormik?.setFieldValue("noComputers", LibraryData?.no_comupters);
        AfflLabFormik?.setFieldValue("nptel", LibraryData?.nptel == true ? "true" : LibraryData?.nptel == false ? "false" : '');
        AfflLabFormik?.setFieldValue("accessOnlineCourse", LibraryData?.access_online_course == true ? "true" : LibraryData?.access_online_course == false ? "false" : '');
        AfflLabFormik?.setFieldValue("noTerminalsInternetConnection", LibraryData?.no_terminals_internet_connection || '');
        AfflLabFormik?.setFieldValue("internetMbps", LibraryData?.internet_mbps);
        AfflLabFormik?.setFieldValue("areaExaminationWing", LibraryData?.area_examination_wing);
        AfflLabFormik?.setFieldValue("computerSystems", LibraryData?.computer_systems);
        AfflLabFormik?.setFieldValue("highSpeed", LibraryData?.high_speed);
        AfflLabFormik?.setFieldValue("internetBandwidth", LibraryData?.internet_bandwidth);
        AfflLabFormik?.setFieldValue("separateRoom", LibraryData?.separate_room == true ? "true" : LibraryData?.separate_room == false ? "false" : '');
        AfflLabFormik?.setFieldValue("supportingStaff", LibraryData?.supporting_staff);

      }
      else {
        // setLibraryFacility([]);
      }
    })
  }

  useEffect(() => {
    GetLibrarySubmittedData();
    GetJournalsSubmittedData();
    GetSoftwareSubmittedData();
    SoftwaresData();
    GetCollegeType();
  }, [])

  const AfflLabFormik = useFormik({
    enableReinitialize: true,
    initialValues: {

      journalsDetails: [
        {
          courseCode: "",
          noOfTitles: "",
          noOfVolumes: "",
          noOfNational: "",
          noOfInternational: "",
          noOfEjournals: "",
        }
      ],
      softwareDetails: [
        {

          slNo: "",
          othersEntry: "",
          softwareCode: "",
          noOfLicenses: "",

        }
      ],

      libraryCarpetArea: "",
      readingRoomCapacity: "",
      repgraphicPhtgraphic: "",
      automationSoftware: "",
      supportingStaff: "",
      booksJournals: "",
      digital: "",
      noComputers: "",
      nptel: "",
      accessOnlineCourse: "",
      noTerminalsInternetConnection: "",
      internetMbps: "",
      areaExaminationWing: "",
      computerSystems: "",
      highSpeed: "",
      internetBandwidth: "",
      separateRoom: "",
    },
    validationSchema: AfflLibraryValidation,

    onSubmit: (values) => {

      const updatedJournalsDetails = values.journalsDetails.map(detail => ({
        courseCode: !isNaN(parseInt(detail.courseCode, 10)) ? parseInt(detail.courseCode, 10) : '',  // Check for NaN
        noOfTitles: detail.noOfTitles || '',
        noOfVolumes: detail.noOfVolumes || '',
        noOfNational: detail.noOfNational || '',
        noOfInternational: detail.noOfInternational || '',
        noOfEjournals: detail.noOfEjournals || '',
      }));

      values.journalsDetails = updatedJournalsDetails;

      const updatedSoftwareDetails = values.softwareDetails.map((detail, index) => ({

        slNo: index + 1,
        softwareCode: parseInt(detail.softwareCode, 10) || '',
        noOfLicenses: detail.noOfLicenses || '',
        othersEntry: detail?.othersEntry || '',

      }));
      const softwareCodes = updatedSoftwareDetails.map(detail => detail.softwareCode);
      const hasDuplicates = softwareCodes.length !== new Set(softwareCodes).size;
      if (hasDuplicates) {
        failureAlert('Duplicate softwareName found, Please select another option');
        return;
      }
      const payload = {
        libraryCarpetArea: parseInt(values.libraryCarpetArea, 10) || '',
        readingRoomCapacity: parseInt(values.readingRoomCapacity, 10) || '',
        repgraphicPhtgraphic: values.repgraphicPhtgraphic,
        automationSoftware: values.automationSoftware,
        supportingStaff: parseInt(values.supportingStaff, 10) || '',
        booksJournals: values.booksJournals || '',
        digital: values.digital,
        noComputers: values.noComputers || '',
        nptel: values.nptel,
        accessOnlineCourse: values.accessOnlineCourse,
        noTerminalsInternetConnection: parseInt(values.noTerminalsInternetConnection, 10) || '',
        internetMbps: parseInt(values.internetMbps, 10) || '',
        areaExaminationWing: values.areaExaminationWing || '',
        computerSystems: parseInt(values.computerSystems, 10) || '',
        highSpeed: values.highSpeed || '',
        separateRoom: values.separateRoom,
        internetBandwidth: values.internetBandwidth || '',
        journalsDetails: updatedJournalsDetails,
        softwareDetails: updatedSoftwareDetails,

      }
      Swal.fire({
        text: 'Are you sure you want to submit?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, submit it!',
        cancelButtonText: 'No, cancel!',
        backdrop: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const url = `${config.url.API_URL}SaveLibraryDetails`;
          CommonAxiosPost(url, payload).then((res) => {
            if (res?.data?.scode === '01') {
              successAlertRefresh(res?.data?.sdesc);
            } else {
              failureAlert(res?.data?.sdesc);
            }
          });
        } else {
          console.log('Submission canceled');
        }
      });
    }
  })


  return (
    <>
      <CommonFormHeading heading="Library Facilties" />
      <bie.Container fluid className="px-1" >

        <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
          <FormikProvider value={AfflLabFormik}>
            <bie.Row className="px-2 pt-3 mb-3">

              <Form onChange={AfflLabFormik.handleChange} onSubmit={AfflLabFormik.handleSubmit} className='affl-form'>
                <bie.Row className="px-2 pt-3 m-0 ">
                  <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                    <label className='mb-1' ><b className='field-mandatory'>Library carpet area ({Collegetype}) : </b></label>
                    <Field type='text' name="libraryCarpetArea" className='form-control mb-2 down-marg4' onKeyPress={(e) => { allowFloatNumbers2(e); }} maxLength="7"
                      onPaste={(e) => handlePaste(e)} />
                    <ErrorMessage name="libraryCarpetArea" component="div" className="text-error" />

                  </bie.Col>
                  <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                    <label className='mb-1' ><b className='field-mandatory'>Reading room seating capacity</b></label>
                    <Field type='text' name="readingRoomCapacity" className='form-control mb-2' onKeyPress={(e) => { allowNumbersOnly(e); }} maxLength={7}
                      onPaste={(e) => handlePaste(e)} />
                    <ErrorMessage name="readingRoomCapacity" component="div" className="text-error" />

                  </bie.Col>
                  <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                    <label className='mb-1' ><b className='field-mandatory'> Number of Staff working in Library</b></label>
                    <Field type='text' name="supportingStaff" className='form-control mb-2' onKeyPress={(e) => { allowNumbersOnly(e); }} maxLength={7}
                      onPaste={(e) => handlePaste(e)} />
                    <ErrorMessage name="supportingStaff" component="div" className="text-error" />

                  </bie.Col>
                  <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                    <label className='mb-1' ><b className='field-mandatory'>Books & Journals</b></label>
                    <Field type='text' name="booksJournals" className='form-control mb-2 down-marg4' onKeyPress={(e) => { allowNumbersOnly(e); }} maxLength={7}
                      onPaste={(e) => handlePaste(e)} />
                    <ErrorMessage name="booksJournals" component="div" className="text-error" />

                  </bie.Col>
                  <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2 d-flex flex-column'>
                    <label className='mb-1' ><b className='field-mandatory'>Reprographic/Photostat facilities </b></label>
                    <div className=''>
                      <Field type="radio" name="repgraphicPhtgraphic" value="true" />&nbsp;Yes&emsp;
                      <Field type="radio" name="repgraphicPhtgraphic" value="false" /> &nbsp; No
                      <ErrorMessage name="repgraphicPhtgraphic" component="div" className="text-error" />
                    </div>

                  </bie.Col>
                  <bie.Col xs={12} sm={12} md={6} lg={4} xl={3} xxl={3} className='mb-2'>
                    <label className='mb-1' ><b className='field-mandatory'>Whether Library automation software is being used : </b></label>
                    &emsp; <Field type="radio" name="automationSoftware" value="true" />&emsp;Yes&emsp;
                    <Field type="radio" name="automationSoftware" value="false" /> &nbsp; No
                    <ErrorMessage name="automationSoftware" component="div" className="text-error" />

                  </bie.Col>
                </bie.Row>
                <div className="table-responsive">
                  <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                    <thead>
                      <tr>
                        <th rowSpan="2">S.No</th>
                        <th rowSpan="2">Course</th>
                        <th colSpan="2">Books Details</th>
                        <th colSpan="3">No. of Journals available	</th>
                      </tr>
                      <tr>
                        <th>No. of titles</th>
                        <th>No. of volumes</th>

                        <th>National</th>
                        <th>International</th>
                        <th>e-journals</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Journals.map((course, index) => (<tr key={index}>
                        <td>{index + 1}</td>
                        <td style={{ textAlign: "left" }}>{course?.details}</td>
                        <td>
                          <Field type="hidden" name={`journalsDetails[${index}].courseCode`} value={course?.course_id} />
                          <Field type="text" className="form-control" name={`journalsDetails[${index}].noOfTitles`} placeholder="No. of Titles"
                            onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} maxLength={7} />
                          <ErrorMessage name={`journalsDetails[${index}].noOfTitles`} component="div" className="text-error" />
                        </td>

                        <td>
                          <Field type="text" className="form-control" name={`journalsDetails[${index}].noOfVolumes`} placeholder="No. of Volumes"
                            onKeyPress={(e) => { allowNumbersOnly(e); }} maxLength={7} onPaste={(e) => handlePaste(e)} />
                          <ErrorMessage name={`journalsDetails[${index}].noOfVolumes`} component="div" className="text-error" />
                        </td>
                        <td>
                          <Field type="text" className="form-control" name={`journalsDetails[${index}].noOfNational`} placeholder="National"
                            onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} maxLength={7} />
                          <ErrorMessage name={`journalsDetails[${index}].noOfNational`} component="div" className="text-error" />
                        </td>
                        <td>
                          <Field type="text" className="form-control" name={`journalsDetails[${index}].noOfInternational`} placeholder="International"
                            onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} maxLength={7} />
                          <ErrorMessage name={`journalsDetails[${index}].noOfInternational`} component="div" className="text-error" />
                        </td>


                        <td>
                          <Field type="text" className="form-control" name={`journalsDetails[${index}].noOfEjournals`} placeholder="e-Journals"
                            onPaste={(e) => handlePaste(e)} onKeyPress={(e) => { allowNumbersOnly(e); }} maxLength={7} />
                          <ErrorMessage name={`journalsDetails[${index}].noOfEjournals`} component="div" className="text-error" />
                        </td>
                      </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="inner-herbpage-service-title-sub">
                  <h1 className="">Digital Library</h1></div>
                <bie.Row className="px-2 my-3">
                  <bie.Row>
                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2 d-flex flex-column'>
                      <label className='mb-1' ><b className='field-mandatory me-2'>Availability </b></label>
                      <div className='down-marg4 form-control'>
                        <Field type="radio" name="digital" value="true" />&nbsp;Yes&emsp;
                        <Field type="radio" name="digital" value="false" /> &nbsp; No
                        <ErrorMessage name="digital" component="div" className="text-error" />
                      </div>

                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                      <label className='mb-1' ><b className='field-mandatory'>No of Computers in reading room</b></label>
                      <Field type='text' name="noComputers" className='form-control mb-2' onKeyPress={(e) => { allowNumbersOnly(e); }} maxLength={7}
                        onPaste={(e) => handlePaste(e)} />
                      <ErrorMessage name="noComputers" component="div" className="text-error" />

                    </bie.Col>

                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2 d-flex flex-column'>
                      <label className='mb-1' ><b className='field-mandatory me-2'>NPTEL learning material</b></label>
                      <div className='down-marg4'>
                        <Field type="radio" name="nptel" value="true" />&nbsp;Yes&emsp;
                        <Field type="radio" name="nptel" value="false" /> &nbsp; No
                        <ErrorMessage name="nptel" component="div" className="text-error" />
                      </div>

                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className='mb-2'>
                      <label className='mb-1' ><b className='field-mandatory me-2'>Facilities to access the Online Courses</b></label>
                      <Field type="radio" name="accessOnlineCourse" value="true" />&nbsp;Yes&emsp;
                      <Field type="radio" name="accessOnlineCourse" value="false" /> &nbsp; No
                      <ErrorMessage name="accessOnlineCourse" component="div" className="text-error" />

                    </bie.Col>
                  </bie.Row>
                </bie.Row>
                <div className="inner-herbpage-service-title-sub">
                  <h1 className="">Internet Connectivity </h1></div>
                <bie.Row className="px-2 my-3">
                  <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                    <label className='mb-1' ><b className='field-mandatory'>No of terminals with internet connection  </b></label>
                    <Field type="text" name="noTerminalsInternetConnection" className="form-control mb-2" onKeyPress={(e) => { allowNumbersOnly(e); }}
                      onPaste={(e) => handlePaste(e)} maxLength={7} />

                    <ErrorMessage name="noTerminalsInternetConnection" component="div" className="text-error" />

                  </bie.Col>
                  <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                    <label className='mb-1' ><b className='field-mandatory'>Internet Bandwidth(Mbps) </b></label>
                    <Field type="text" name="internetMbps" className="form-control down-marg4 mb-2" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => { allowNumbersOnly(e); }}
                      maxLength={7} />
                    <ErrorMessage name="internetMbps" component="div" className="text-error" />

                  </bie.Col>
                </bie.Row>
                <div className="inner-herbpage-service-title-sub">
                  <h1 className="">Examination Control Office</h1></div>
                <bie.Row className='px-2 my-3'>
                  <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                    <label className='mb-1' ><b className='field-mandatory'>Area Provided ({Collegetype}) </b></label>
                    <Field type="text" name="areaExaminationWing" className="form-control down-marg4" maxLength="10" onKeyPress={(e) => { allowFloatNumbers2(e); }} />

                    <ErrorMessage name="areaExaminationWing" component="div" className="text-error" />

                  </bie.Col>
                  <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                    <label className='mb-1' ><b className='field-mandatory'>Number of computer systems </b></label>
                    <Field type="text" name="computerSystems" className="form-control down-marg4" onKeyPress={(e) => { allowNumbersOnly(e); }} maxLength={7}
                      onPaste={(e) => handlePaste(e)} />

                    <ErrorMessage name="computerSystems" component="div" className="text-error" />

                  </bie.Col>
                  <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                    <label className='mb-1' ><b className='field-mandatory'>No of High Speed copier machines </b></label>
                    <Field type="text" name="highSpeed" className="form-control" onKeyPress={(e) => { allowNumbersOnly(e); }} maxLength={7}
                      onPaste={(e) => handlePaste(e)} />

                    <ErrorMessage name="highSpeed" component="div" className="text-error" />

                  </bie.Col>
                  <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                    <label className='mb-1' ><b className='field-mandatory'>Internet Bandwidth(Mbps) </b></label>
                    <Field type="text" name="internetBandwidth" className="form-control down-marg4" onKeyPress={(e) => { allowNumbersOnly(e); }} maxLength={7} />

                    <ErrorMessage name="internetBandwidth" component="div" className="text-error" />
                  </bie.Col>
                  <bie.Col xs={12} sm={12} md={6} lg={4} xl={3} xxl={3} className='mb-2'>
                    <label className='mb-1' ><b className='field-mandatory'>Separate rooms for confidential work Avalable or not</b></label>
                    <div className='form-control'>
                      <Field type="radio" name="separateRoom" value="true" />&nbsp;Yes&emsp;
                      <Field type="radio" name="separateRoom" value="false" /> &nbsp; No
                      <ErrorMessage name="separateRoom" component="div" className="text-error" />
                    </div>

                  </bie.Col>
                </bie.Row>
                <bie.Row className="px-2 pt-3 mb-3">
                  <div className="table-responsive">
                    <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                      <thead>
                        <tr>
                          <th>SNO</th>
                          <th> Software	</th>
                          <th>No of Licenses</th>
                          <th>Action</th>

                        </tr>
                      </thead>
                      <tbody>
                        <FieldArray name="softwareDetails">
                          {(QualificationValues) => {
                            return QualificationValues.form.values.softwareDetails.map((qual, index) => {
                              return (
                                <>
                                  <tr key={index}>
                                    <td>
                                      <center>{index + 1}</center>
                                    </td>

                                    <td><Field as="select"
                                      className="form-control form-control-md"
                                      name={`softwareDetails[${index}].softwareCode`}
                                      style={{ width: '48rem' }} >
                                      <option value=''>--SELECT--</option>
                                      {software && software.map((sw, i) => (
                                        <option value={sw?.software_code}>{sw?.software_name}</option>
                                      ))} </Field> <br />
                                      {AfflLabFormik?.values?.softwareDetails[index]?.softwareCode === "9999" && (
                                        <Field
                                          type="text"
                                          className="form-control form-control-md"
                                          name={`softwareDetails[${index}].othersEntry`}
                                          style={{ width: '48rem' }} />)}
                                      <ErrorMessage name={`softwareDetails[${index}].othersEntry`} component="div" className="text-error" />


                                      <ErrorMessage name={`softwareDetails[${index}].softwareCode`} component="div" className="text-error" />
                                    </td>
                                    <td>

                                      <Field typr="text" onKeyPress={(e) => { allowNumbersOnly(e); }} maxLength={8} name={`softwareDetails[${index}].noOfLicenses`}
                                        className="form-control form-control-md"
                                      ></Field>

                                      <ErrorMessage name={`softwareDetails[${index}].noOfLicenses`} component="div" className="text-error" />
                                    </td>

                                    <td align="center">
                                      {index === 0 ? (
                                        <button
                                          type="button"
                                          className="button-titile btn btn-sm btn-success"
                                          onClick={() => {
                                            QualificationValues.push({
                                              slNo: "",
                                              softwareCode: "",
                                              noOfLicenses: "",
                                              othersEntry: "",

                                            });
                                          }}
                                        >
                                          <VscDiffAdded></VscDiffAdded>{" "}
                                        </button>
                                      ) : ""}
                                      {index !== 0 ? (
                                        <button type="button" className="button-titile btn btn-sm btn-danger"
                                          onClick={() => QualificationValues.remove(index)} >

                                          <BiTrash></BiTrash>
                                        </button>
                                      ) : ""}
                                    </td>




                                  </tr>
                                </>
                              );
                            });
                          }}


                        </FieldArray>

                        {/* <tr className='table-active'> */}
                        {/* <td >
                          <FieldArray name="softwareDetails">
                            {(formikFieldArray) => {
                              return formikFieldArray.form.values.softwareDetails.map((LJP, i) => {
                                return (<>
                                  {(i === 0) ? <> <button type="button" className="button-titile btn btn-sm btn-success me-4 text-end"
                                    onClick={() => {
                                      formikFieldArray.push({
                                        slNo: "",
                                        softwareCode: "",
                                        noOfLicenses: "",
                                        othersEntry: "",

                                      });
                                    }}>
                                    <VscDiffAdded></VscDiffAdded>
                                  </button> </> : ''}
                                </>)
                              })
                            }}
                          </FieldArray>
                        </td> */}
                        {/* </tr> */}
                      </tbody>
                    </table>
                  </div></bie.Row>

                <div className="button-cend pt-1 mb-4">
                  <button type='submit' className='btn btn-success btn-sm float-end'>Submit</button>
                </div>
                <br />
              </Form>
            </bie.Row>
          </FormikProvider>
        </bie.Container>
      </bie.Container>
    </>
  )
}
